enum Priority {
    URGENT = 1,
    MEDIUM = 2,
    SUGGESTION = 3
}

enum ConfigFolio {
    APPROVE = "APPROVE",
    REJECT = "REJECT"
}
export { Priority, ConfigFolio }
